// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"0448ae88","193":"911d64d5","237":"1b9ca5dc","332":"80efa32a","341":"3230cbe9","434":"2bee93fd","523":"9078dae7","731":"83907d28","767":"ad2d2d70","947":"cca08491"}[chunkId] + ".chunk.js";
};